import { cn } from '~/lib/utils';
import excelIcon from '~/landing_page/Assets/Excel.png';
import styles from './WidgetCard.module.css';

export interface CsvMetricsCardProps {
  className?: string;
  filename?: string;
  rows?: { label: string; value: string }[];
}

export const CsvMetricsCard = ({
  className,
  filename = 'sprint_34_metrics.csv',
  rows = [
    { label: 'Story points', value: '84 / 91' },
    { label: 'Bugs closed', value: '17' },
    { label: 'Carry-over', value: '3' },
  ],
}: CsvMetricsCardProps) => {
  return (
    <div className={cn(styles.card, className)}>
      <div className={styles.row}>
        <img src={excelIcon} className={styles.icon} alt="Excel" />
        <div className={styles.body}>
          <p className={styles.title}>{filename}</p>
          <div className={styles.table}>
            {rows.map((row) => (
              <div key={row.label} className={styles.tableRow}>
                <div className={styles.tableCell}>
                  <span>{row.label}</span>
                </div>
                <div className={cn(styles.tableCell, styles.tableCellValue)}>
                  <span>{row.value}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

CsvMetricsCard.displayName = 'CsvMetricsCard';
